<template>
  <div class="selectDate">
    <a-date-picker
      style="width: 100%"
      :placeholder="date"
      :disabledDate="disabledDate"
      @change="confirmDate"
      valueFormat='YYYY/MM/DD'
      v-model:value="date"
    >
      <template #suffixIcon><span style='color:rgba(0, 0, 0, 0.65);'>{{ weekDate }}</span></template>
    </a-date-picker>
  </div>
</template>
<script>
import { ref } from 'vue'
import moment from "moment"
export default {
  componentname: "datePicker",
  props: {
    date: {
      type : String,
      default:''
    }

  },
  setup (props, context) {
    // console.log(props.date)
    // 日期范围
    const disabledDate = (current) => {
      return current < moment().add(-1, 'd') || current > moment().add(30, 'd')
    }
    // 选择日期
    let weekDate = ref('今天')
    let confirmDate = (date, dateString) => {
      // console.log(date, dateString)
      context.emit('calendar', dateString)
      // 星期几
      let tmpnewchar = ""
      switch (new Date(date).getDay()) {
        case 0: tmpnewchar = "星期日"; break
        case 1: tmpnewchar = "星期一"; break
        case 2: tmpnewchar = "星期二"; break
        case 3: tmpnewchar = "星期三"; break
        case 4: tmpnewchar = "星期四"; break
        case 5: tmpnewchar = "星期五"; break
        case 6: tmpnewchar = "星期六"; break
      }
      weekDate.value = tmpnewchar
    }

  
    return {
      disabledDate,
      weekDate,
      confirmDate
    }
  }
}
</script>
<style  rel="stylesheet/scss" lang="scss" scoped>
</style>
